import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentType} from "../../types/agent.type";
import {EmploymentType} from "../../types/employment.type";
import * as _ from "lodash";
import {PhoneAndEmailFactoryService} from "../../../commons/services/phone-and-email-factory.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {AgentsService} from "../../services/agents-service.service";
import {
  AgentConfigurationProfilesService
} from "../../../configuration-profiles/services/agent-configuration-profiles-service.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class CreateAgentFormCtrl implements IController {

  agent: AgentModel;
  canEditExternalId: boolean;
  enablePassword: any;
  isEdit: any;
  autoStopRecordingIntervalMinutes?: number;
  onAutoStopRecordingIntervalMinutesChange: Function;

  public originalAgent: AgentModel;
  public form: any;
  private skillsByType: any;
  private country: any;
  private passwordPolicy: any;
  private employmentTypes: EmploymentType[];
  public limitingSingleTimezone?: boolean;
  public logisticsVehicleTypeIds: string[];
  public attachedLogisticsVehicleReferencesIds: string[];
  public showAutoStopRecordingIntervalMinutes?: boolean;
  public showConfigurationProfile: boolean;
  public agentType: typeof AgentType = AgentType;
  public configurationAgentTypesQuery: AgentType[];
  public isCreatingUsingExistingUser: boolean;
  public isUserExistsInDifferentSite: boolean;
  public existingUserDetails: any;
  public isUserAgentActive: boolean;
  public isAgentExternalIdMandatory: boolean;
  public zxExtras: string[] = [];

  constructor(private IamService, private $log, private splitService: SplitService,
              private IAMPermissions: IAMPermissionsService, private agentConstants, private agentsService: AgentsService, private commonsService: CommonsService,
              private phoneAndEmailFactoryService: PhoneAndEmailFactoryService, private agentConfigurationProfilesService: AgentConfigurationProfilesService) {
  }

  $onInit() {
    this.originalAgent = angular.copy(this.agent)
    this.skillsByType = this.agentConstants.skillsByType;
    this.country = this.splitService.getCountryCode();
    this.passwordPolicy = this.splitService.getSitePasswordPolicy();
    this.limitingSingleTimezone = this.splitService.getLimitingSingleTimezone();
    this.employmentTypes = [EmploymentType.Payroll, EmploymentType.Independent];
    this.showConfigurationProfile = this.IAMPermissions.hasPermission('site.configuration.list');

    if (!!this.agent) {
      this.configurationAgentTypesQuery = this.agent.agentType === this.agentType.Robot ? [this.agentType.Robot] : [this.agentType.ServiceAgent, this.agentType.Driver, this.agentType.Manager];
    }


    if (!!this.agent) {
      this._setLogisticsVehicleTypeIds(this.agent.vehicle);
      this.attachedLogisticsVehicleReferencesIds = _.flatMap(this.agent.attachedLogisticsVehicleReferences || [], 'id');
    }
  }

  onPhoneChange(mobilePhone, form) {
    this.agent.user.mobilePhone = mobilePhone;
  }

  onColorChange(color) {
    this.agent.displayColor = color;
  }

  onEmailChange(email, form) {
    // this.phoneAndEmailFactoryService.emailFormValidation(email, form, 'email');

    form['email'].$setValidity('existsInDifferentSite', true);
    form['email'].$setValidity('exists', true);

    this._zxExtras();

    if (!email) {
      return;
    }
    this.agentsService.getAgentCrossSiteData(email, undefined)
      .then((res: any) => {

        if (!res.hasUser) {
          return
        } else if (!res.userHasAgentInThisSite) {
          form['email'].$setValidity('existsInDifferentSite', false);
          this.isUserExistsInDifferentSite = true;
          this.isUserAgentActive = res.userHasActiveAgentInAnotherSite;
          this.existingUserDetails = res.agentUserData;
        } else {
          form['email'].$setValidity('exists', false);
        }
      })
  }

  onCreateUsingExistingUser(form) {
    this.isCreatingUsingExistingUser = true;
    this.agent.user = this.existingUserDetails;
    this.agent.active = !this.isUserAgentActive;
    form['email'].$setValidity('existsInDifferentSite', true);
  }

  onPasswordChange(password: string) {
    this.agent.user.password = password;
  }

  onAgentTypeSelect(agentType: AgentType) {
    this.agent.agentType = agentType;
    this.agent.agentConfigurationProfileId = undefined;
    this.agent.skills = AgentType ? [this.skillsByType[agentType][0]] : [];

    this.configurationAgentTypesQuery = this.agent.agentType === this.agentType.Robot ? [this.agentType.Robot] : [this.agentType.ServiceAgent, this.agentType.Driver, this.agentType.Manager];


    if (agentType === AgentType.Robot) {
      this.agent.user.userType = 'Robot';
      this._resetFieldsForRobotFields();
    } else {
      this._resetRobotFields();

      if (!!this.showConfigurationProfile && agentType) {
        this.agentConfigurationProfilesService.getDefaultAgentProfile([agentType])
          .then((defaultProfile) => {
            this.agent.agentConfigurationProfileId = _.get(defaultProfile, 'id')
          })
      }
    }
  }

  onSessionRecordingChange(sessionRecording?) {
    if (!this.originalAgent.sessionRecording) {
      this.showAutoStopRecordingIntervalMinutes = !!sessionRecording;
    }

    if (!sessionRecording) {
      this.autoStopRecordingIntervalMinutes = undefined;
      this.onAutoStopRecordingIntervalMinutesChange({autoStopRecordingIntervalMinutes: this.autoStopRecordingIntervalMinutes})
    }
  }

  onAgentSkillSelect(ids) {
    this.agent.skills = ids;
  }

  onBranchesSelect(branchIds) {
    this.agent.branchIds = branchIds;
  }

  onTimeZoneChange(zoneId) {
    this.agent.zoneId = zoneId;
  }

  onVehicleSelect(vehicle) {
    this.agent.vehicle = vehicle;
    this.agent.mainLogisticsVehicleReference = undefined;
    this._setLogisticsVehicleTypeIds(vehicle)
  }

  onLogisticsVehicleSelect(logisticsVehicle) {
    this.agent.mainLogisticsVehicleReference = logisticsVehicle ? {id: logisticsVehicle.id} : undefined;
  }

  onAttachedLogisticsVehicleSelect(ids) {
    this.attachedLogisticsVehicleReferencesIds = ids;
    this.agent.attachedLogisticsVehicleReferences = _.map(ids, (id) => {
      return {id: id};
    })
  }

  onConfigurationProfileSelect(profileId: string) {
    if (this.isEdit && !profileId) {
      this.agent.agentConfigurationProfileId = "";
    } else {
      this.agent.agentConfigurationProfileId = profileId;
    }
  }

  onTagChange(tagName) {
    this.agent.tags = tagName;
  }

  private _setLogisticsVehicleTypeIds(vehicle) {
    this.logisticsVehicleTypeIds = vehicle ? [vehicle.id] : undefined;
  }

  private _resetFieldsForRobotFields() {
    _.unset(this.agent.user, 'mobilePhone');
    _.unset(this.agent.user, 'email');
    _.unset(this.agent.user, 'password');
    _.unset(this.agent, 'sessionRecording');
    _.unset(this.agent, 'mainLogisticsVehicleReference');
    _.unset(this.agent, 'attachedLogisticsVehicleReferences');

    this.attachedLogisticsVehicleReferencesIds = undefined;
    this.autoStopRecordingIntervalMinutes = undefined;
    this.onAutoStopRecordingIntervalMinutesChange({autoStopRecordingIntervalMinutes: undefined})
  }

  private _resetRobotFields() {
    _.unset(this.agent.user, 'userType');
    _.unset(this.agent.user, 'uniqueId');
  }


  private _zxExtras() {
    this.zxExtras = this.agent.user?.email ?
      this.commonsService.buildZxExtras(this.agent.user.email) :
      [];
  }

}

angular
  .module('bringoz.admin.agents')
  .component('createAgentForm', {
    require: {
      form: '^form'
    },
    bindings: {
      agent: '<',
      canEditExternalId: '<?',
      isAgentExternalIdMandatory: '<?',
      enablePassword: '<?',
      isEdit: '<?',
      onAutoStopRecordingIntervalMinutesChange: '&'
    },
    template: require('./create-agent-form.html').default,
    controller: CreateAgentFormCtrl
  });
